import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, position } from 'styled-system';
import Text, { TextProps } from '../text/Text';

export type H3Props = Omit<TextProps, 'tag'> & { tag?: 'h3' };

const StyledH3: React.FC<H3Props> = ({ children, tag, ...otherProps }) => (
    <Text h3 tag="h3" {...otherProps}>
        {children}
    </Text>
);

const H3 = styled(StyledH3)`
    line-height: ${({ theme }) => theme.lineHeights.title};
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${position}
`;

H3.displayName = 'H3';
export default H3;
